import Cookies from 'js-cookie'
import { global } from '../config'
import { Toast } from 'antd-mobile';
import wx from 'weixin-js-sdk'

export function formatValidityDate(date, flag = '.') {
  let times = date.substring(0, date.indexOf(' ')).split('-');

  if (flag == '.') {
    return times[1] + '.' + times[2]
  } else {
    return '未知';
  }
}
//获取链接参数
export function getQueryString(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg);
  // let r = window.location.search.substr(1).replace('?', '&').match(reg);
  if (r !== null) return decodeURIComponent(r[2]);
  return 0;
}
//判断是否微信环境
export function isWeChat() {
  let navigator = window.navigator.userAgent.toLowerCase();
  let flag = 0

  if (navigator.match(/MicroMessenger/i) == 'micromessenger') {
    flag = 1
    wx.miniProgram.getEnv(function (res) {
      if (res.miniprogram) { //微信小程序
        flag = 5
      }
    })
    return flag;
  } else {
    if (navigator.match(/Alipay/i) == 'alipay') {
      return 2;
    } else if (navigator.match(/native_iOS/i) == 'native_ios') {
      return 3;
    } else if (navigator.match(/android_huhu/i) == 'android_huhu') {
      return 4
    }
  }
  return 0;
}

export function isInMobileApp() {
  let currentClient = isWeChat();
  let clientList = [3, 4]
  return clientList.indexOf(currentClient) !== -1;
}

// js与客户端交互
export function jsCallApp(obj) {
  if (whichSystem() === 11) {
    window.jsCallNative && window.jsCallNative.jsCallAndroid ? window.jsCallNative.jsCallAndroid(JSON.stringify(obj)) : jumpApp(obj);
  } else if (whichSystem() === 12) {
    window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsCallNative && window.webkit.messageHandlers.jsCallNative.postMessage ? window.webkit.messageHandlers.jsCallNative.postMessage(obj) : jumpApp(obj);
  }
}


//那一个系统
export function whichSystem() {
  let navigator = window.navigator.userAgent.toLowerCase();
  if (navigator.indexOf('android') > -1) {
    return 11;
  } else if (/(iphone|ipad|ipod|ios)/i.test(navigator)) {
    return 12;
  }
  return false;
}

/**
 * 微信授权
 */
export function wxAuthorize() {
  let client = isWeChat()
  if (client === 1) {
    let url = global.wxAuthorizeBaseUrl
    url += '&base_url=' + window.location.href
    window.location.href = url + '&from_openid=' + Cookies.get('from_openid') + '&activity_id=' + Cookies.get('activity_id')
  } else if (client === 3 || client === 4) {
    window.location.href = window.location.href + '#hh:' + encodeURI('{opentype:back}')
  } else {
    goLogin()
  }
}

export function hourconvertMicrosecond(hour) {
  let interval = 60 * 60 * 1000
  return interval * hour
}
export function appShare(id) {
  window.location.href = global.href + '#hh:' + encodeURI('{\"opentype\":\"share\",\"openvar\":\"' + id + '\"}')
}

/**
 * 跳转APP方法
 * @param params
 */
export function jumpApp(params) {
  let { entries } = Object;
  let str = '';
  for (let [key, value] of entries(params)) {
    if (str.length > 0) {
      str += ','
    }
    str += '\"' + key + '\":\"' + value + '\"'
  }
  window.location.href = global.href + '#hh:' + encodeURI('{' + str + '}')
}

/**
 * 跳转APP内部 webview
 */
export function jumpAppWebView(router, parameter) {
  let url = window.location.protocol + '//' + window.location.host + router + window.location.search;
  if (parameter != undefined && parameter != 'undefined') {
    url = url.indexOf('?') == -1 ? url + '?' : url;
    url += parameter
  }
  window.location.href = url
}

export function wxShareUrl(params) {
  return global.href + 'fission/beinvite?' + params
}

//时间解析
export function getDateByStr(sDate) {
  if (sDate) {
    let dDate = new Date(Date.parse(sDate.replace(/-/g, "/")));
    return dDate
  }
}

export function minuteFormat(sDate) {
  if (sDate) {
    let d1 = new Date(Date.parse(sDate.replace(/-/g, "/")))
    let d2 = new Date()

    let s1 = d1.getTime();
    let s2 = d2.getTime();
    let total = (s2 - s1) / 1000;

    let day = parseInt(total / (24 * 60 * 60));//计算整数天数
    if (day > 0) {
      return day + '天';
    }

    let hour = parseInt(total / (60 * 60));//计算整数小时数
    if (hour > 0) {
      return hour + '小时';
    }

    let min = parseInt(total / 60);//计算整数分
    return min + '分'
  } else {
    return ''
  }
}

export function urlJump(params) {
  window.location.href = window.location.protocol + '//' + window.location.host + params
}

//小程序跳转
export function mpNavigateTo(url, params) {
  wx.miniProgram.navigateTo({
    url: url
  })
}

export function goLogin() {
  Toast.offline('去登录')
  urlJump('/login')
}

export function openMiniProgramPage(item) {
  let url = '/pages/home/home'
  if (item.opentype == 'theme' || item.opentype == 'viptheme') {
    if (!item.isvideo) {
      if (item.openvar && item.openvar != 0) {
        url = '/pages/cate/cate?id=' + item.openvar
      }
    } else {
      if (item.openvar && item.openvar != 0) {
        url = '/pages/video/video?id=' + item.openvar
      }
    }
  } else if (item.opentype == 'cate') { //分类
    if (item.openvar && item.openvar != 0) {
      url = '/pages/category/list/list?id=' + item.openvar + '&name=' + item.openvar
    }
  } else if (item.opentype == 'story') {
    if (!item.isvideo) {
      if (item.openvar && item.openvar != 0 && item.cate_id > 0) {
        url = '/pages/player/player?cateid=' + item.cate_id + '&storyid=' + item.openvar
      }
    } else {
      if (item.openvar && item.openvar != 0 && item.cate_id > 0) {
        url = '/pages/video/video?id=' + item.cate_id + '&storyid=' + item.openvar
      }
    }
  } else if (item.opentype == 'link' || item.opentype == 'link_share') {
    url = '/pages/webview/webview?url=' + encodeURIComponent(item.openvar)
  } else if (item.opentype == 'answer') {
    url = '/pages/survey/index?url=' + encodeURIComponent(item.openvar)
  } else if (item.opentype == 'newest') {
    url = '/pages/home/new/new'
  } else if (item.opentype == 'app_within') {
    if (item.openvar == 'my_vip') {
      url = '/pages/vip/index'
    }
  }
  wx.miniProgram.navigateTo({
    url: url
  })
}

export function hex2bin(str) {
  let sbin = "";
  for (let i = 0; i < str.length; i += 2) {
    var v = str.substr(i, 2);
    sbin += String.fromCharCode(parseInt(v, 16))
  }
  return sbin;
}

export function todayFormat() {
  let date = new Date()
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

export function timeFormat(date, num, symbol) {
  if (!date) {
    return date;
  }
  if (num) {
    date = date.substr(0, num)
  }
  if (symbol) {
    date = date.replace(/-/g, symbol)
  }
  return date
}

export function getNickName(nickname) {
  let myreg = /^\d{11}$/;
  let name = nickname
  if (myreg.test(nickname)) {
    name = nickname.substr(0, 3) + '****' + nickname.substr(-4)
  }
  return name
}

export function getUrlParams() {
  let url = window.location.search; //获取url中"?"符后的字串
  let urlRequest = new Object();
  if (isWeChat() == 1) {
    urlRequest = {
      os: 'wechat'
    }
  } else {
    //不需要传参，跟微信端同步
    if (false && url.indexOf("?") != -1) {
      let str = url.substr(1);
      let strs = str.split("&");
      for (let i = 0; i < strs.length; i++) {
        if (strs[i].split("=")[0] != 'sign') {
          urlRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
    }
  }

  if (urlRequest.os) {
    Cookies.set('urlRequest', urlRequest, {
      expires: 1 //1day
    })
  } else {
    let CookiesUrlRequest = Cookies.get('urlRequest') ? JSON.parse(Cookies.get('urlRequest')) : '';
    if (CookiesUrlRequest && CookiesUrlRequest.os) {
      urlRequest = CookiesUrlRequest
    }
  }
  urlRequest.os = urlRequest.os ? urlRequest.os : 'h5'
  return urlRequest
}

const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

export function formatMTime(currentTime) {
  let nowTime = parseInt(currentTime);
  let nowTimeMinute = parseInt(nowTime / 60);
  let nowTimeSecond = nowTime - parseInt(nowTime / 60) * 60;
  return [nowTimeMinute, nowTimeSecond].map(formatNumber).join(':')
}

export function getAllTime(duration) {
  let times = duration.split(':');
  let allTime = Number(times[0]) * 60 * 60 + Number(times[1]) * 60 + Number(times[2])
  return allTime
}
/**
 * 倒计时
 * @param leftTime 要倒计时的时间戳
 */
export function countdown(leftTime) {
  let bool = false
  if (leftTime <= 0) {
    bool = true
    return { bool }
  }
  var days = parseInt(leftTime / 1000 / 60 / 60 / 24, 10) //计算剩余的天数
  var hours = parseInt(leftTime / 1000 / 60 / 60 % 24, 10)
  if (hours < 10) {
    hours = '0' + hours
  }
  var minutes = parseInt(leftTime / 1000 / 60 % 60, 10)
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  var seconds = parseInt(leftTime / 1000 % 60, 10)
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  return { bool, days, hours, minutes, seconds }
}

/**
 * 百度统计初始化
 */
export function baiduStatistics() {
  var _hmt = _hmt || [];
  (function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?18fd37d414145c525285e6cf0f11dada";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
}

/**
 * 发送事件分析
 * @param pageName  页面名称
 * @param action    动作
 * @param flag      标签/id
 */
export function baiduStatisticsBehaviour(pageName, action, flag) {
  if (typeof window._hmt == 'undefined') return;
  window._hmt.push(['_trackEvent', pageName, action, flag, 1]);
}

/**
 * 跳转应用宝参数
 */
export function jumpYYB(behaviour, pageName) {
  pageName = pageName.replace(/\//g, '_');

  if (behaviour.length === 0) {
    behaviour = pageName + '_jump'
  }
  let str = 'http://a.huhustory.com/Data/co-operation.php?classid=6&usercode=' + behaviour + '&date='
  let url = str + pageName
  window.location.href = url
}

/**
 * 初始化基础参数
 */
export function initParameter() {

  let cookiePrefix = global.cookiePrefix;

  let sign = getQueryString('sign');
  let sso_id = getQueryString('sso_id');
  let openId = getQueryString('openid') ? getQueryString('openid') : getQueryString('openId');
  let groupBuyId = getQueryString('groupbuy_id')

  let clearName = cookiePrefix + 'clearNow' + groupBuyId;

  let clear = Cookies.get(clearName);
  //毫秒
  let timestamp = new Date().getTime();

  let debug = getQueryString('debug');


  if (clear == 'undefined' || clear == undefined || (timestamp - clear >= 3600000) || debug == 2) {
    Cookies.remove('sso_id');
    Cookies.remove(cookiePrefix + 'sign')
    Cookies.remove(cookiePrefix + 'sso_id')
    Cookies.remove(cookiePrefix + 'openid')
    Cookies.set(clearName, timestamp)

  } else {
    sign && Cookies.set(cookiePrefix + 'sign', sign);
    sso_id && Cookies.set(cookiePrefix + 'sso_id', sso_id);
    openId && Cookies.set(cookiePrefix + 'openid', openId);
  }

  if (debug == 1) {
    alert('sso_id ===>' + Cookies.get(cookiePrefix + 'sso_id'));
    alert('openid ===>' + Cookies.get(cookiePrefix + 'openid'));

  }

}

export function checkLogin() {
  //在H5下需要验证sign 和 sso_id  在客户端下 需要验证sign和from_sso_id
  if (getParameter('sign') &&
    ((getParameter('sso_id') && getParameter('openid')) ||
      (isInMobileApp() &&
        (getParameter('from_sso_id') || getParameter('sso_id'))))) {
    return true;
  }
  return false;
}


export function setCookie(key, value) {
  let cookiePrefix = global.cookiePrefix;
  Cookies.remove(cookiePrefix + key)
  Cookies.set(cookiePrefix + key, value)
}
export function getCookie(key) {
  let cookiePrefix = global.cookiePrefix;
  return Cookies.get(cookiePrefix + key)
}
export function delCookie(key) {
  let cookiePrefix = global.cookiePrefix;
  return Cookies.remove(cookiePrefix + key)
}


export function getParameter(param) {
  let cookiePrefix = global.cookiePrefix;
  let val = Cookies.get(cookiePrefix + param) || getQueryString(param)
  if (!val) {
    return 0
  }
  return val
}

/*
   * 参数说明：
   * number：要格式化的数字
   * decimals：保留几位小数
   * dec_point：小数点符号
   * thousands_sep：千分位符号
   * */
export function number_format(number, decimals, dec_point, thousands_sep) {
  number = (number + '').replace(/[^0-9+-Ee.]/g, '');
  let n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
    sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
    dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return '' + Math.ceil(n * k) / k;
    };

  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  let re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, "$1" + sep + "$2");
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}

// 识别非法字符/emoji
export function character(val) {
  let reg = /select|insert|update|CR|document|LF|eval|delete|script|alert|union|into|load_file|outfile/ig;
  let reg1 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E|\uff0b|\u2795][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030|\uff0b|\u2795/ig; // 识别emoji

  if (reg.test(val) || reg1.test(val)) {
    return false;
  }
  return true;
}

export function imageUrl(str, size) {

  // let dataSize = ['100-100', '200-200', '250-100', '260-125', '300-300', '400-400', '560-210', '600-600', '320-180', '800-800'];
  //对于存储在阿里云并且传入数据库完整地址的数据处理
  /*if(str.match(/huhuapp-images.huhustory.com/i) == 'huhuapp-images.huhustory.com'){
  }*/
  if (!str) {
    return ''
  }

  if (str.indexOf("huhuapp-images.huhustory.com") !== -1) {
    str = str.replace('http://', '').replace('https://', '').replace('huhuapp-images.huhustory.com/open/Public/Uploads', '');
    //传入加密地址或多余的参数的数据处理
    if (str.indexOf("?") !== -1) {
      str = str.match(/(\S*)\?/)[1];
    }
  }

  //http开头。不是阿里云存储的图片，直接返回（原则上不存在这样的图片，可能有用户图像等）
  if (str.substr(0, 4) === "http") return str;

  let OSS = require('ali-oss');
  let store = new OSS({
    //region: 'oss-cn-hangzhou', //oss-cn-hangzhou.aliyuncs.com
    //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，部署在服务端使用RAM子账号或STS，部署在客户端使用STS。
    accessKeyId: 'Hadn7yO0PJGB8FgV',
    accessKeySecret: 'nCDMNAJRM1jUXc6rsEODXw5US8fWVH',
    cname: true,
    bucket: 'huhuapp-image',
    endpoint: 'huhuapp-images.huhustory.com'
  });
  return store.signatureUrl('open/Public/Uploads' + str, {
    expires: 3600,
    // process: 'image/resize,w_200,h_200',
    method: 'GET'
  });
}


// WEBPACK FOOTER //
// ./src/utils/utils.js